"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const wallet_core_sdk_1 = require("@affinidi/wallet-core-sdk");
const randombytes_1 = __importDefault(require("randombytes"));
const KeysService_1 = __importDefault(require("./KeysService"));
class WalletStorageService extends wallet_core_sdk_1.__dangerous.WalletStorageService {
    constructor(encryptedSeed, password, options = {}) {
        super(encryptedSeed, password, options);
        this._keysService = new KeysService_1.default(encryptedSeed, password);
        this._credentialsIdsAndIndexesMap = {};
    }
    createEncryptedMessageByMyKey(object) {
        return __awaiter(this, void 0, void 0, function* () {
            const { seed, didMethod } = this._keysService.decryptSeed();
            const seedHex = seed.toString('hex');
            const publicKeyHex = KeysService_1.default.getPublicKey(seedHex, didMethod);
            const encryptedMessage = yield this._keysService.encryptByPublicKey(publicKeyHex, object);
            return encryptedMessage;
        });
    }
    encryptCredentials(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const encryptedCredentials = [];
            /* istanbul ignore else: code simplicity */
            if (data.length && data.length > 0) {
                for (const item of data) {
                    const cyphertext = yield this.createEncryptedMessageByMyKey(item);
                    encryptedCredentials.push(cyphertext);
                }
            }
            return encryptedCredentials;
        });
    }
    decryptCredentials(blobs) {
        return __awaiter(this, void 0, void 0, function* () {
            const decryptedCredentials = [];
            /* istanbul ignore else: code simplicity */
            if (blobs && blobs.length) {
                for (const blob of blobs) {
                    const credential = yield this._keysService.decryptByPrivateKey(blob.cyphertext);
                    const isW3cCredential = wallet_core_sdk_1.__dangerous.isW3cCredential(credential);
                    let key = credential.id;
                    if (!isW3cCredential && credential.data) {
                        key = credential.data.id;
                    }
                    if (!key) {
                        key = yield randombytes_1.default(8).toString('hex');
                    }
                    this._credentialsIdsAndIndexesMap[key] = blob.id;
                    decryptedCredentials.push(credential);
                }
            }
            return decryptedCredentials;
        });
    }
    findCredentialIndexById(id) {
        const credentialIndexToDelete = this._credentialsIdsAndIndexesMap[id];
        if (!credentialIndexToDelete && credentialIndexToDelete !== 0) {
            throw new wallet_core_sdk_1.__dangerous.SdkError('COR-23', { id });
        }
        return credentialIndexToDelete;
    }
}
exports.default = WalletStorageService;
//# sourceMappingURL=WalletStorageService.js.map